import {isValidLucideIconComponent} from '@/components/icon/Icon.utils';
import {pascalCase} from 'change-case';
import {icons, type LucideProps} from 'lucide-react';

interface IconProps extends LucideProps {
  name?: string;
}

export default function Icon({name, ...props}: IconProps) {
  const componentName = pascalCase(name || '');

  if (!isValidLucideIconComponent(componentName)) {
    return null;
  }

  const Icon = icons[componentName];

  return <Icon {...props} />;
}
